export function normalizeTaxpayer(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

export function normalizeCpf(value) {
    return String(value || '').replace(/\D/g, '');
}

export function isCpf(value) {
    return validateCpf(value);
}

export function isCnpj(value) {
    return validateCnpj(value);
}

export function formatCnpj(value) {
    const cnpj = normalizeTaxpayer(value).slice(0, 14);
    return cnpj
            .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
            .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
            .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
            .replace(/([A-Z0-9]{4})(\d{1,2})$/, '$1-$2');
}

export function validateCpf(value) {
    const cpf = normalizeCpf(value);

    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

    const calculateDigit = (base) => {
        let sum = 0;

        for (let index = 0; index < base.length; index++) {
            sum += Number(base[index]) * (base.length + 1 - index);
        }

        const rest = (sum * 10) % 11;
        return rest === 10 ? 0 : rest;
    };

    return calculateDigit(cpf.slice(0, 9)) === Number(cpf[9])
            && calculateDigit(cpf.slice(0, 10)) === Number(cpf[10]);
}

export function validateCnpj(value) {
    const cnpj = normalizeTaxpayer(value);

    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;
    if (/^(\d)\1{13}$/.test(cnpj)) return false;

    const calculateDigit = (base, factorStart) => {
        let sum = 0;
        let factor = factorStart;

        for (const char of base) {
            sum += (char.charCodeAt(0) - 48) * factor;
            factor -= 1;
            if (factor < 2) factor = 9;
        }

        const rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
    };

    const base = cnpj.slice(0, 12);
    const firstDigit = calculateDigit(base, 5);
    const secondDigit = calculateDigit(`${base}${firstDigit}`, 6);

    return cnpj === `${base}${firstDigit}${secondDigit}`;
}

export function isCompleteTaxpayer(value) {
    const normalized = normalizeTaxpayer(value);
    return normalized.length === 11 || normalized.length === 14;
}
